export default {
    "已有账号？": "Hast du bereits ein Konto?",
    "去登录": "Zum Login",
    "投注": "Wette",
    "请先绑定银行卡": "Bankkarte zuerst",
    "服务评分": "Servicebewertung",
    "历史": "Verlauf",

    "绑定上限，请联系客服!": "Limit erreicht, Kundenservice!",
    "已达绑定上限": "Bindungslimit erreicht",
    "任务详情": "Aufgabendetails",
    "投票详情": "Abstimmungsdetails",
    "获得金额": "Erhaltene Summe",
    "待结算": "Ausstehende Abrechnung",
    "再来一次": "Noch einmal",
    "时间": "Zeit",
    "备注": "Bemerkung",

    accountDetailTab: {
        "充值": 'Aufladen',
        "提现": 'Auszahlung',
        "投票": 'Abstimmung',
    },
    "选择{name}": "Wählen Sie {name}",
    "个人简介": "Persönliches Profil",
    "投票金额": "Abstimmungsbetrag",
    "投票记录": "Abstimmungsverlauf",
    "投票方向": "Abstimmungsrichtung",
    "下注金额": "Einsatzbetrag",
    "投票": "Abstimmen",
    "确认投票": "Abstimmung bestätigen",
    "银行账户号码": "Bankkontonummer",
    "提现到": "Auszahlen an",
    "去绑定": "Jetzt verknüpfen",
    "信誉分": "Kreditwürdigkeit",
    "立即预约": "Jetzt buchen",
    "取款方式": "Auszahlungsart",

    "住所": "Wohnsitz",
    "照片": "Foto",
    "胸围": "Brust",
    "约炮推荐": "Hookup-Empfehlung",
    "高端专区": "Premium-Bereich",
    "暂无信息": "Keine Informationen",
    "观影券": "Film-Gutschein",
    "观影券不足": "Nicht genügend Film-Gutscheine",
    "详情信息": "Detailinformationen",
    "银行卡": "Bankkarte",
    "x次认证": "{num}-fach verifiziert",
    "请输入您的收款卡信": "Bitte geben Sie Ihre Zahlungsinformationen ein",
    "绑定银行卡": "Bankkarte verknüpfen",
    "绑定USDT地址": "USDT-Adresse verknüpfen",
    "请选择{name}": "Bitte wählen Sie {name}",
    "请输入{name}": "Bitte geben Sie {name} ein",
    "银行地址": "Bankadresse",
    "银行账户": "Bankkonto",
    "ABA/路由代码": "ABA/Routing-Code",
    "SWIFT代码": "SWIFT-Code",
    "姓名": "Name",
    "虚拟币": "Kryptowährung",
    "币种": "Währung",
    "地址": "Adresse",
    "确认绑定": "Bindung bestätigen",
    "银行列表": "Bankliste",
    "暂无数据": "Keine Daten",
    "充值": "Aufladen",
    "旧密码": "Altes PW",
    "新密码": "Neues PW",
    "请输入您的旧密码": "Altes PW eingeben",
    "请输入您的新密码": "Neues PW eingeben",
    "请再次输入您的新密码": "PW erneut eingeben",
    "修改登录密码": "PW ändern",
    "收款卡信息": "Karteninfo",
    "投票结果": "Ergebnis",

    tabbar: {
        "首页": "Start",
        "预约": "Buchen",
        "地区选择": "Region",
        "视频": "Video",
        "我的": "Mein"
    },
    "高端": "Premium",
    "认证": "Verifiziert",
    "视频认证": "Video-Verifizierung",
    "收费区间": "Preisspanne",
    "身高": "Größe",
    "胸圍": "Brustumfang",
    "服務城市": "Stadt",
    "全國空降": "Überregional",
    "是": "Ja",
    "否": "Nein",
    "我要约她": "Buchen",
    "城市大全": "Städte",
    "流程价格": "Ablaufpreis",
    "刷新成功": "Erfolgreich aktualisiert",
    "预约大厅": "Buchungshalle",
    "全部": "Alle",
    "查看更多": "Mehr",
    "推荐任务": "Empfohlene Aufgaben",
    "人气排行": "Beliebtheit",
    "热门推荐": "Top-Empfehlung",
    "获取中": "Laden",
    "语言": "Sprache",
    "登录": "Anmelden",
    "忘记密码": "Passwort vergessen",
    "没有账户？马上注册": "Kein Konto? Jetzt registrieren",
    "请输入用户名": "Benutzername eingeben",
    "请输入密码": "Passwort eingeben",
    "注册": "Registrieren",
    "我已经知晓并同意'开户协议'各项条约": "Ich stimme den Bedingungen zu",
    "请输入邀请码": "Einladungscode eingeben",
    "请输入用户名({min}-{max}个英文字母或数字)": "Benutzername ({min}-{max} Zeichen)",
    "请输入登录密码({min}-{max}个英文字母或数字)": "Passwort ({min}-{max} Zeichen)",
    "请勾选下方开户协议": "Bitte Bedingungen zustimmen",
    "可用余额": "Verfügbares Guthaben",
    "元": "Yuan",
    "提交": "Einreichen",
    "当前选号": "Aktuelle Auswahl",
    "每注金额": "Betrag pro Einsatz",
    "请输入金额": "Betrag eingeben",
    "总共": "Gesamt",
    "注": "Einsätze",
    "合计": "Summe",
    "任务单": "Aufgabenliste",
    "1注X{money}元={money}元": "1 Einsatz X {money} = {money}",
    "清空订单": "Bestellung löschen",
    "确认提交": "Bestätigen",
    "期号": "Losnummer",
    "第{x}期": "{x}. Los",
    "数据": "Daten",
    "双": "Gerade",
    "单": "Ungerade",
    "未选择": "Nicht gewählt",
    "金额错误": "Falscher Betrag",
    "请选号": "Nummern wählen",
    "请填写金额": "Betrag eingeben",
    "余额不足，请联系客服充值！": "Guthaben nicht ausreichend, kontaktieren Sie den Support!",
    "未选中": "Nicht ausgewählt",
    "请联系管理员领取该任务": "Admin kontaktieren",
    "开奖成功，期号：": "Ziehung erfolgreich, Nr.:",
    "大": "Groß",
    "小": "Klein",
    "填写收款卡": "Karte eingeben",
    "请输入您的收款卡信息": "Kartendaten eingeben",
    "银行卡号": "Kartennummer",
    "请输入真实银行卡号": "Gültige Kartennummer eingeben",
    "银行名称": "Bankname",
    "请选择银行": "Bank auswählen",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "Name und Passwort zur Sicherheit angeben",
    "确认绑卡": "Karte bestätigen",
    "请输入银行卡号": "Kartennummer eingeben",
    "任务记录": "Aufgabenhistorie",
    "任务记录Title": "Aufgabenhistorie",
    "数据为空": "Keine Daten",
    "下单时间": "Bestellzeit",
    "结算时间": "Abrechnungszeit",
    "提现": "Auszahlung",
    "我的钱包": "Mein Wallet",
    "详情": "Details",
    "余额": "Saldo",
    "个人报表": "Bericht",
    "账户明细": "Kontodetails",
    "个人中心": "Profil",
    "信息公告": "Mitteilungen",
    "在线客服": "Kundendienst",
    "请完成任务单后进入": "Nach Abschluss betreten",
    "请联系客服充值": "Support kontaktieren",
    "请设置收款卡": "Karte festlegen",
    "功能已禁用": "Funktion deaktiviert",
    "账号下线": "Konto ausgeloggt",
    "登录/注册": "Anmelden/Registrieren",
    "登录可享受更多服务": "Für mehr Dienste anmelden",
    "基本信息": "Basisinfo",
    "头像": "Avatar",
    "选择头像": "Avatar wählen",
    "确定": "OK",
    "取消": "Abbrechen",
    "真实姓名": "Echter Name",
    "未设置": "Nicht festgelegt",
    "性别": "Geschlecht",
    "绑定信息": "Gebundene Info",
    "已绑定": "Gebunden",
    "无": "Keine",
    "男": "Männlich",
    "女": "Weiblich",
    "未知": "Unbekannt",
    "系统公告": "Systeminfo",
    "盈利金额": "Gewinn",
    "盈利计算公式 : 中奖金额 - 任务金额": "Gewinn = Gewinnbetrag - Einsatz",
    "任务金额": "Aufgabenbetrag",
    "充值金额": "Aufladebetrag",
    "提现金额": "Auszahlungsbetrag",
    "中奖金额": "Gewinnbetrag",
    "客服": "Support",
    "蜜獾娱乐": "Honey Badger",
    "联系": "Kontakt",
    "全天7 * 24小时竭诚为您服务": "24/7 Service",
    "添加收款卡": "Karte hinzufügen",
    "提示:请绑定大型商业银行,如需修改,请您联系在线客服": "Hinweis: Große Banken nutzen",
    "修改真实姓名": "Name ändern",
    "保存": "Speichern",
    "请输入真实姓名": "Echten Namen eingeben",
    "为了您账户安全,真实姓名需要与绑定银行卡姓名一致": "Name muss Karte entsprechen",
    "请勿重复设置": "Nicht erneut festlegen",
    "请输入姓名": "Namen eingeben",
    "请输入资金密码": "Passwort eingeben",
    "设置资金密码": "Passwort festlegen",
    "请再次输入资金密码": "Passwort erneut eingeben",
    "请填写完整": "Bitte ausfüllen",
    "两次密码不一致": "Passwörter stimmen nicht überein",
    "性别修改": "Geschlecht ändern",
    "设置": "Festlegen",
    "基本信息设置": "Grundeinstellung",
    "登录密码": "Passwort",
    "资金密码": "Zahlungspasswort",
    "退出登录": "Abmelden",
    "已设置": "Eingestellt",
    "提现密码已设置，需要修改请联系客服": "Passwort ändern: Support kontaktieren",
    "提现中心": "Auszahlungscenter",
    "提现记录": "Auszahlungsverlauf",
    "1.单笔限额：最低{min}元，最高{max}元": "1. Limit: Min {min}, Max {max}",
    "2.提现次数：一天最高提现{num}次": "2. Max {num} Auszahlungen/Tag",
    "3.到账时间": "3. Zeit: ~15 Min, langsam 2 Std",
    "限额说明": "Limits",
    "马上提现": "Jetzt auszahlen",
    "请填写正确的金额": "Gültigen Betrag eingeben",
    "金额": "Betrag",
    "说明": "Hinweis",
    "提交时间": "Einreichzeit",
    "审核时间": "Prüfzeit",
    "视频影院": "Video-Kino",
    "没有更多了": "Keine weiteren",
    "播放": "Abspielen",
    "x播放": "xAbspielen",
    "首页": "Startseite",
    "选妃": "Wählen",
    "选妃列表": "Liste",
    "选妃详情": "Details",
    "语言选择": "Sprache wählen",
    "我的": "Mein",
    "视频": "Video",
    "游戏": "Spiel",
    "修改性别": "Geschlecht ändern",
    "支付密码管理": "Passwort-Manager",
    "登录密码管理": "Anmeldepasswort",
    "详情页面": "Detailseite",
    "视频播放": "Videowiedergabe",

    "本期":"Aktuelle Periode",
    "剩余时间":"Verbleibende Zeit",
    "立即投票":"Jetzt abstimmen",
    "提前预订卡进度":"Fortschritt der Vorausbuchungskarte",

    "预订状态":"Buchungsstatus",
}
